import { Component } from '@angular/core';
import { CellRendererComponent } from '@valg-shared/components/table/directives/cell-component-outlet/cell-component-outlet.directive';
import { getValueAt } from "@valg-shared/utils/object-utils";
import { Column } from '@valg-shared/components/table/table/column';

@Component({
  selector: 'valg-dk-link-renderer',
  templateUrl: './link-renderer.component.html'
})
export class LinkRendererComponent implements CellRendererComponent {
  text = "";
  id!: string;
  link!: string;

  public init(data: unknown, column: Column): void {
    this.text = getValueAt(data, column.path); 
    this.id = getValueAt(data, 'id'); 
    let link = column.metadata?.rendererOptions?.get('link');
    
    if(link && typeof link === 'string'){
      this.link = link;
    }
  }

}

